import { defineMessages } from 'react-intl';

export const shipToStepMessages = defineMessages({
  nameLabel: {
    defaultMessage: 'Name',
    id: '93rg0f',
    description: 'Label for the recipient name field in the ship-to step',
  },
  namePlaceholder: {
    defaultMessage: 'First and Last Name',
    id: 'Aw8A2T',
    description: 'Placeholder for the recipient name field',
  },
  companyLabel: {
    defaultMessage: 'Company',
    id: 'YVZsaf',
    description: 'Label for the company field in the ship-to step',
  },
  companyPlaceholder: {
    defaultMessage: 'Enter Company Name',
    id: 'Tna9/p',
    description: 'Placeholder for the company field',
  },
  addressLine1Label: {
    defaultMessage: 'Address Line 1',
    id: 'nY0yxH',
    description: 'Label for the first address line in the ship-to step',
  },
  addressLine2Label: {
    defaultMessage: 'Address Line 2',
    id: 'rK61nR',
    description: 'Label for the second address line in the ship-to step',
  },
  cityLabel: {
    defaultMessage: 'City',
    id: 'hGfkIJ',
    description: 'Label for the city field in the ship-to step',
  },
  stateLabel: {
    defaultMessage: 'State',
    id: 'QFBQjh',
    description: 'Label for the state dropdown in the ship-to step',
  },
  statePlaceholder: {
    defaultMessage: 'Select state',
    id: 'fqg+Bv',
    description: 'Placeholder for the state dropdown',
  },
  zipCodeLabel: {
    defaultMessage: 'Zip Code',
    id: 'vfssf8',
    description: 'Label for the zip code field in the ship-to step',
  },
  phoneLabel: {
    defaultMessage: 'Phone Number',
    id: 'OFUYhO',
    description: 'Label for the phone number field in the ship-to step',
  },
  phonePlaceholder: {
    defaultMessage: '(000) 000 - 0000',
    id: '2Vrog6',
    description: 'Placeholder for the phone number field',
  },
  emailLabel: {
    defaultMessage: 'Email (Optional)',
    id: 'U0eyun',
    description: 'Label for the optional email field in the ship-to step',
  },
  emailPlaceholder: {
    defaultMessage: 'Enter email',
    id: 'a72G72',
    description: 'Placeholder for the email field',
  },
  saveAsNewCustomer: {
    defaultMessage: 'Save as new customer',
    id: 'OIrzs4',
    description: 'Checkbox label to save the recipient as a new customer',
  },
  deliveryServicesHeader: {
    defaultMessage: 'Delivery Services',
    id: 'JTgJAU',
    description: 'Header for the delivery services checkbox grid',
  },
  tradeshowNameLabel: {
    defaultMessage: 'Tradeshow Name *',
    id: 'lgnUEn',
    description: 'Label for the required tradeshow name field revealed by Tradeshow Delivery',
  },
  boothNumberLabel: {
    defaultMessage: 'Booth Number *',
    id: 'fKk9O/',
    description: 'Label for the required booth number field revealed by Tradeshow Delivery',
  },
  destinationSectionLabel: {
    defaultMessage: 'Destination',
    id: '5kDtL0',
    description: 'Section label for the destination address in the ship-to step summary',
  },
  tradeshowLine: {
    defaultMessage: 'Tradeshow: {name} • Booth: {booth}',
    id: 'q3qDaU',
    description: 'Tradeshow summary line shown in the ship-to step summary when tradeshow delivery is selected',
  },
  tradeshowNameOnly: {
    defaultMessage: 'Tradeshow: {name}',
    id: 'vNqNBo',
    description: 'Tradeshow summary line when only the name is present',
  },
  tradeshowBoothOnly: {
    defaultMessage: 'Booth: {booth}',
    id: 's4N4CY',
    description: 'Tradeshow summary line when only the booth number is present',
  },
  saveAsDefaultSelections: {
    defaultMessage: 'Save as default settings for this Customer',
    id: '+MOy0r',
    description: 'Checkbox label to save delivery services and instructions as LTL Defaults for this customer (no existing defaults)',
  },
  updateDefaultSelections: {
    defaultMessage: 'Update default settings for this Customer',
    id: 'ibFyXc',
    description: 'Checkbox label to update existing LTL Defaults for this customer (defaults already exist)',
  },
  ltlDeliveryDefaultsHelperText: {
    defaultMessage:
      'These Delivery Services and Instructions will apply to all future LTL shipments to this customer. Defaults can be managed in the customer record.',
    id: 'IMK2Ul',
    description: 'Helper text below the save-as-default checkbox in the Ship To wizard step',
  },
  deliveryInstructionsLabel: {
    defaultMessage: 'Delivery Instructions',
    id: 'D9+jmM',
    description: 'Label for the delivery instructions toggle and textarea in the Ship To wizard step',
  },
});
